export default "__VITE_ASSET__1ee8362a__"